<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-row style="background-color: #F3F4F4;">
	  	<el-col :xs="24" :md="6" style="display:flex;align-items:center;font-weight: bold;padding-top: 10px;padding-bottom: 10px;">
            <i style="color:#676767;font-size: 16px;margin-right: 12px;" class="el-icon-s-tools"></i>
	  		安全设置
	  	</el-col>
	  </el-row>
        <el-row>
            <el-col class="tabBtn">
                <el-button v-no-more-click type="primary" :class="{ active: index == activeIndex }" v-for="(item, index) in headMetaBtn" :key="index" @click="handleHeadMetaBtn(index)">{{item.name}}</el-button>
            </el-col>
        </el-row>
        <!-- 弹窗, 修改密码 -->
        <loginpwd v-if="activeIndex == 0" ref="loginpwd"></loginpwd>
        <paypwd v-else ref="paypwd"></paypwd>
    </el-card>
  </template>
  
  <script>
import loginpwd from './loginpwd.vue'
import paypwd from './paypwd.vue'
  export default {
    data () {
      return {
        activeIndex:0,
        headMetaBtn: [
            {name:'修改登录密码'},
            {name:'修改支付密码'},
        ],
      }
    },
    components: {
        loginpwd,
        paypwd
    },
    created(){
    },
    methods:{
        // 切换
        handleHeadMetaBtn(index){
            this.activeIndex = index;
        },
    }
  }
  </script>
  